const ruleConditionType = {
    BINARY : 'binary',

    BINDING : 'binding',

    COMPOSITE : 'composite',

    RAW : 'raw',

    UNARY : 'unary'

};

angular.module('gw-um-j2js')
    .constant('ruleConditionType', ruleConditionType);